"use client";

import { useContext, useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import { InlineDiv } from "@/common/divs";
import PageContent from "@/components/home";
import PrerenderActivities from "@/components/home/preRenderActivities";
import SearchContext from "@/context/searchContext/searchContext";
import { useFixHydration } from "@/hooks/useFixHydration";
import { Category } from "@/model";
import { SearchContextType } from "@/types/components";
import { PRIMARY_BUTTON_COLOR } from "@/utils/constants";

export type WildcardRootContentProps = {
  latitude: number;
  longitude: number;
  radius: number;
  term: string;
  communityId?: string;
  isActivity: boolean;
};
export const WildcardRootContent = ({
  data,
  category,
}: {
  data: WildcardRootContentProps | null;
  category?: Category;
}) => {
  const { saveSearchInfo, saveCategory } = useContext(
    SearchContext,
  ) as SearchContextType;
  const [searchOnce, setSearchOnce] = useState(false);
  useEffect(() => {
    if (data?.communityId && !searchOnce) {
      setSearchOnce(true);
      saveSearchInfo({
        id: data?.communityId,
        community: data?.term,
      });
    }
    if (category && category.id && !searchOnce) {
      saveCategory(category.id.toString());
      setSearchOnce(true);
    }
  }, [category, data, saveSearchInfo, searchOnce, saveCategory]);

  const mounted = useFixHydration();

  if (!mounted) {
    return null;
  }

  if (data?.communityId && !searchOnce) {
    return (
      <InlineDiv
        paddingY="200px"
        style={{ justifyContent: "center", minHeight: "400px" }}
      >
        <CircularProgress style={{ color: PRIMARY_BUTTON_COLOR }} size={50} />
      </InlineDiv>
    );
  }

  if (!data) {
    return <PrerenderActivities />;
  }

  return (
    <PageContent
      latitude={data?.latitude ?? 0}
      longitude={data?.longitude ?? 0}
      city={data?.term ?? ""}
      category={category?.id ?? 0}
      radius={data?.radius ?? 0}
    />
  );
};
